import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import _toLower from 'lodash/toLower'
import { useSelector } from 'react-redux'
import { get as getConfig } from 'config'
import { TARGET_BLANK, TextLink } from 'components/Link'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'
import { selectPath } from 'services/resolver/selectors'
import { selectAuthorized, selectAuth } from 'services/auth'
import {
  URL_MARKETPLACE_LOGGED_IN,
  URL_LIVE_PAGE,
  URL_GAIA_PLUS,
  URL_GAIA_PLUS_EVENTS,
  URL_GAIA_PLUS_ALL_GUIDES,
  URL_ARCHIVED_WORKSHOPS,
} from 'services/url/constants'
import { LIVE_ACCESS_SUBSCRIPTION_CODE } from 'services/live-access-events/constants'
import { EN, ES } from 'services/languages/constants'
import { selectUserLanguages } from 'services/user'
import { isShop } from 'services/url'

export function rearrangeGaiaPlusItem (item, isUserLivePlan, language) {
  let label = item.get('label')
  let url = item.get('url')

  if (isUserLivePlan && language === EN) {
    if (url === URL_GAIA_PLUS) {
      label = 'On Demand'
      url = URL_GAIA_PLUS_EVENTS
    } else if (url === URL_GAIA_PLUS_EVENTS) {
      label = 'Guides'
      url = URL_GAIA_PLUS_ALL_GUIDES
    } else if (url === URL_GAIA_PLUS_ALL_GUIDES) {
      label = 'Upcoming Events'
      url = URL_GAIA_PLUS
    }
  }

  if (url === URL_ARCHIVED_WORKSHOPS && isUserLivePlan) {
    label = language === ES ? 'Eventos pasados' : 'Past Events'
  }

  return {
    label,
    url,
  }
}

const getItemClassName = (isActive) => {
  const className = ['navigation-primary-v2__mobile-item']

  if (isActive) className.push('active')

  return className.join(' ')
}

const getIsActive = (pathname, url, children = List()) => {
  if (pathname === url) {
    return true
  }

  if (children.size) {
    return children.some((child) => child.get('url', '') === pathname)
  }

  return false
}

const MobileNavItem = ({
  item, handleItemClick,
}) => {
  const [isChildrenOpen, setChildrenOpen] = useState(false)

  const pathname = useSelector(selectPath)
  const isLoggedIn = useSelector(selectAuthorized)
  const auth = useSelector(selectAuth)
  const language = useSelector(selectUserLanguages).get(0, EN)

  const trackingId = item.get('trackingId', -1)
  let url = item.get('url')
  const label = item.get('label', '')
  const children = item.get('children', List())
  const isActive = getIsActive(pathname, url, children)
  const hasChildren = !!children.size
  const isShopLink = isShop(url)
  const isUserLivePlan = auth.get('subscriptions') && auth.get('subscriptions').includes(LIVE_ACCESS_SUBSCRIPTION_CODE)

  if (isShopLink && !getConfig().features.navShopLinkV3) {
    return null
  }

  if (isShopLink && isLoggedIn) {
    url = URL_MARKETPLACE_LOGGED_IN
  }

  if (url === URL_GAIA_PLUS && isUserLivePlan && language === EN) {
    url = URL_GAIA_PLUS_EVENTS
  }

  return (
    <li
      key={`mobile-${trackingId}`}
      className={getItemClassName(isActive)}
    >
      {isShopLink && (
        <a
          className="navigation-primary-v2__mobile-link"
          data-id={trackingId}
          href={isLoggedIn ? URL_MARKETPLACE_LOGGED_IN : url}
          target={TARGET_BLANK}
          rel="noreferrer"
        >
          <span>{label}</span>
        </a>
      )}
      {hasChildren && (
        <a
          className="navigation-primary-v2__mobile-link"
          onClick={() => setChildrenOpen(!isChildrenOpen)}
        >
          <span>{label}</span>
          <IconV2
            className="navigation-primary-v2__mobile-arrow"
            type={isChildrenOpen ? ICON_TYPES.ARROW_UP : ICON_TYPES.ARROW_DOWN}
          />
        </a>
      )}
      {!hasChildren && !isShopLink && (
        <TextLink
          to={url || pathname}
          text={label}
          data-href={url}
          onClick={() => handleItemClick(`${trackingId} - ${_toLower(label)}`)}
          data-id={trackingId}
          className="navigation-primary-v2__mobile-link"
        >
          <span>{label}</span>
        </TextLink>
      )}
      {hasChildren && isChildrenOpen && (
        <ul className="navigation-primary-v2__mobile-children-item">
          {
            children.map((child) => {
              if (child.get('url', '') === URL_LIVE_PAGE && !isUserLivePlan) {
                return null
              }

              const {
                url: childUrl,
                label: childLabel,
              } = rearrangeGaiaPlusItem(child, isUserLivePlan, language)

              const childTrackinghId = child.get('trackingId')

              return (
                <li
                  key={`mobile-${childTrackinghId}`}
                  className={getIsActive(pathname, childUrl) ? 'active' : ''}
                >
                  <TextLink
                    className="navigation-primary-v2__mobile-link"
                    to={childUrl}
                    text={childLabel}
                    data-href={childUrl}
                    onClick={() => handleItemClick(`${childTrackinghId} - ${_toLower(childLabel)}`)}
                    data-id={childTrackinghId}
                  />
                </li>
              )
            })
          }
        </ul>
      )}
    </li>
  )
}

MobileNavItem.propTypes = {
  item: ImmutablePropTypes.map.isRequired,
  handleItemClick: PropTypes.func,
}

export default MobileNavItem
